import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractRowTemplate from "./AbstractRowTemplate.js";
import SpacerRow from "../../reports/rows/SpacerRow.js";

/**
 * Spacer row template. It does nothing more than displaying an empty row
 * (line).
 *
 * @param {boolean} [spec.horizontalLine = false] - Whether the spacer displays
 * an horizontal line.
 * @param {boolean} [spec.short = true] - Whether the spacer row
 * has a short or long row height.
 */
export default class SpacerRowTemplate extends AbstractRowTemplate {
	constructor({ horizontalLine = false, short = true } = {}) {
		super(...arguments);
		this._horizontalLine = horizontalLine;
		this._short = short;
	}

	setHorizontalLine(boolean) {
		this._horizontalLine = boolean;
	}

	setShort(boolean) {
		this._short = boolean;
	}

	isHorizontalLine() {
		return this._horizontalLine;
	}

	isShort() {
		return this._short;
	}

	isValidFormulaReference() {
		return false;
	}

	isVisibleWhenNoData() {
		return true;
	}

	accept(visitor) {
		return visitor.visitSpacerRowTemplate(this);
	}

	_instanceClass() {
		return SpacerRow;
	}

	_interpretationSpec() {
		const spec = super._interpretationSpec(...arguments);
		spec.horizontalLine = this._horizontalLine;
		spec.short = this._short;

		return spec;
	}

	_serializedProperties() {
		const properties = super._serializedProperties(...arguments);

		properties.horizontalLine = this._horizontalLine;
		properties.short = this._short;

		return properties;
	}

	static getLabel() {
		return _("Separator");
	}

	static getType() {
		return "SpacerRowTemplate";
	}
}
